// blogSlice.ts
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "../../../api/services";

interface BlogsState {
  blogList: any;   
  blogDetail: any; 
  latestBlogs: any; 
  loading: boolean;
  error: string | null;
}

const initialState: BlogsState = {
  blogList: null,
  blogDetail: null,
  latestBlogs: null,
  loading: false,
  error: null,
};

// ✅ Get all blogs
export const fetchBlogs = createAsyncThunk("blogs/fetch", async () => {
  const res = await API.get("/blogs");
  return res.data;
});

// ✅ Get blog by slug
export const fetchBlogBySlug = createAsyncThunk("blogs/fetchBySlug", async (slug: string) => {
  const res = await API.get(`/blog/${slug}`);
  return res.data;
});

// ✅ Get latest blogs
export const fetchLatestBlogs = createAsyncThunk("blogs/fetchLatest", async (limit: number = 5) => {
  const res = await API.get(`/blogs/latest?limit=${limit}`);
  return res.data;
});

const blogSlice = createSlice({
  name: "blogs",
  initialState,
  reducers: {
    setBlogState: (state, action) => {
      state.blogList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // all blogs
      .addCase(fetchBlogs.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBlogs.fulfilled, (state, action) => {
        state.loading = false;
        state.blogList = action.payload;
      })
      .addCase(fetchBlogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Error fetching blogs";
      })

      // blog by slug
      .addCase(fetchBlogBySlug.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBlogBySlug.fulfilled, (state, action) => {
        state.loading = false;
        state.blogDetail = action.payload;
      })
      .addCase(fetchBlogBySlug.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Error fetching blog detail";
      })

      // latest blogs
      .addCase(fetchLatestBlogs.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLatestBlogs.fulfilled, (state, action) => {
        state.loading = false;
        state.latestBlogs = action.payload;
      })
      .addCase(fetchLatestBlogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Error fetching latest blogs";
      });
  },
});

export const { setBlogState } = blogSlice.actions;
export default blogSlice.reducer;
